import React from "react"
import {Button, ButtonGroup, Col, FormGroup, Glyphicon, InputGroup} from "react-bootstrap"
import Select from "react-select"
import {BootstrapTable} from "react-bootstrap-table"

export const renderFilterButtons = (onFilterReset, size = 4, onExport = null, canReset = true) => {
	return <Col xs={size}>
		<ButtonGroup className="pull-right">
			{canReset && <Button type="reset" bsStyle="default" onClick={onFilterReset} title="Zrušit filtr">
				<Glyphicon glyph="remove" className="text-muted"/></Button>}
			{onExport && <a href={onExport()} className="btn btn-success" title="Exportovat vše dle filtru">
				<Glyphicon glyph="export"/></a>}
			<Button type="submit" bsStyle="primary">
				<Glyphicon glyph="filter"/> <span className={"hidden-md"}>Vyhledat</span></Button>
		</ButtonGroup>
	</Col>
}

export const renderSelect = (name, placeholder, value, options, handleSelectChange, searchable = false, multi = false, clearable = true) => {
	return <FormGroup>
		<Select
			// className="form-control"
			value={value}
			name={name}
			multi={multi}
			// delimiter="|"
			// joinValues={true}
			clearable={clearable}
			backspaceRemoves={clearable}
			deleteRemoves={clearable}
			searchable={searchable}
			placeholder={placeholder}
			options={options}
			simpleValue={!multi}
			clearValueText="Vymazat"
			clearAllText="Vymazat vše"
			noResultsText="(nic nenalezeno)"
			onChange={(val) => {
				handleSelectChange(name, val, true)
			}}>
		</Select>
	</FormGroup>
}

export const getTableOptions = (filter, onPageChange = null, onSortChange = null, onFilterChange = null, renderPaginationShowsTotal = null) => {
	const currentSize = (1 * filter.rows) || 1
	const sizePerPageList = [
		{text: '15', value: 15},
		{text: '50', value: 50},
		{text: '100', value: 100},
		{text: '200', value: 200}]
	if (currentSize !== 15 && currentSize !== 50 && currentSize !== 100 && currentSize !== 200) {
		sizePerPageList.unshift({text: currentSize, value: currentSize})
	}

	const options = {
		sizePerPage: (1 * filter.rows) || 15,
		sizePerPageList: sizePerPageList,
		hideSizePerPage: !onFilterChange,
		onSizePerPageList: (newSize) => {
			filter.rows = newSize
			document.cookie = "pageRows=" + newSize + "; expires=Thu, 18 Dec 2030 12:00:00 UTC; path=/"
		},
		page: ((filter.start || 0) / filter.rows) + 1,
		noDataText: 'Nic nenalezeno',
		paginationShowsTotal: renderPaginationShowsTotal,
		onPageChange: onPageChange,
		onSortChange: onSortChange,
		onFilterChange: onFilterChange
	}
	if (onFilterChange) {
		options.sortName = filter.orderCol
		options.sortOrder = filter.orderDir
	}

	return options
}

export const renderTableActions = (actionCtx) => {
	if (!actionCtx || !actionCtx.actions || !actionCtx.actions.length) {
		return null
	}
	const options = []
	for (let i = 0; i < actionCtx.actions.length; i++) {
		options.push({value: actionCtx.actions[i].value, label: actionCtx.actions[i].label})
	}

	return <div className="pull-left table-actions">
		<FormGroup>
			<InputGroup>
				<Select
					value={actionCtx.value}
					name="actions"
					placeholder="Hromadná akce"
					options={options}
					clearValueText="Vymazat"
					clearAllText="Vymazat vše"
					onChange={(val) => {
						actionCtx.onActionSelect(val)
					}}>
				</Select>
				{actionCtx.value !== null && <div className="input-group-btn">
					<Button type="submit" bsStyle="success" onClick={actionCtx.onActionSubmit} title="Provést akci"><Glyphicon glyph="ok"/></Button>
				</div>}
			</InputGroup>
		</FormGroup>
	</div>
}

export const renderTable = (items, count, options, cols, pagination = true, striped = true, ref = "table", header = true, formatRow = null, actionCtx = null) => {

	return <BootstrapTable data={items} keyField={actionCtx && actionCtx.key ? actionCtx.key : "id"} selectRow={actionCtx ? actionCtx.selectRowProp : undefined} remote={true} condensed={true}
		pagination={pagination} fetchInfo={{dataTotalSize: count}}
		striped={striped} hover={true} ref={ref} headerContainerClass={header ? "" : "hidden"}
		options={options} trClassName={formatRow}>
		{cols}
	</BootstrapTable>
}

export const renderFull = (isFetchingItems, items, count, options, cols, filterForm, onFilterChange, actionCtx = null, formatRow = null) => {
	if (actionCtx !== null && actionCtx.actions.length) {
		const wrapped = options.paginationShowsTotal
		options.paginationShowsTotal = (start, to, total) => {
			return wrapped(start, to, total, actionCtx)
		}
	}

	return <div>
		<form onSubmit={onFilterChange} className="filter-form">
			{filterForm}
		</form>
		{(items === null || isFetchingItems) ? renderIsFetchingData() : renderTable(items, count, options, cols, true, true, "table", true, formatRow, actionCtx)}
	</div>
}

export const renderPaginationShowsTotal = (isFetchingCount, start, to, total, actionCtx = null) => {
	if (isFetchingCount) {
		return <p className="pull-left pagination-total"><Glyphicon glyph="refresh" className="spin"/></p>
	}

	return (
		<div><p className="pull-left pagination-total">{start}-{to} / {total}</p>{renderTableActions(actionCtx)}</div>
	)
}

export const renderIsFetchingData = (text = 'Nahrávám ...') => {
	return <div className="loading-text"><Glyphicon glyph="refresh" className="spin"/> {text}</div>
}

export const renderIsDenied = () => {
	return <div className="loading-text"><Glyphicon glyph="remove"/> Nedostatečná oprávnění.</div>
}


// WEBPACK FOOTER //
// ./P:/Work/htdocs/biatlon/online/src/components/utils/grid.js